import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { merge } from 'rxjs/observable/merge';
import { filter, map, mergeMap } from 'rxjs/operators';
import { ApiService } from '@app/utility/api.service';

import { environment } from '@env/environment';
import { Logger, I18nService } from '@app/core';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { UtilService } from '@app/utility/util.service';
import { UserService } from "@app/user.service";
import { AuthService } from "@app/auth.service";
import { SocketioService } from '@app/socketio.service'; 
import { timer } from 'rxjs/observable/timer'

@Component({
  selector: 'app-singlegatewaywait',
  templateUrl: './singlegatewaywait.component.html',
  styleUrls: ['./singlegatewaywait.component.scss']
})
export class SinglegatewaywaitComponent implements OnInit {

   
  _subscription: any
  
  PortalUser: any;
  
  timeLeft: number = 3600; 
  message: string = ""

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private translateService: TranslateService,
    private i18nService: I18nService,
    private Util: UtilService,
    private Api: ApiService,
    private user: UserService,
    private Auth: AuthService,
    private socketService: SocketioService,
    private idle: Idle,
    private keepalive: Keepalive) {
      
      this._subscription = this.socketService.caller.subscribe((data: any) => {
        if(data && data["referenceId"] == sessionStorage.getItem("referenceId")){
          let thisTs = this;
          let result = data["result"]
          if(result == 'Y')
          {  
            this.Util.SuccessDialog("ท่านได้ทำการยืนยันตัวตนสำเร็จ"); 
            thisTs.router.navigate(["/mainmenu/refundDeposits"]);

          }
          else
          { 
              this.Util.ErrorDialog("ท่านทำการยืนยันตัวตนไม่สำเร็จ กรุณายืนยันตัวต้นใหม่อีกครั้ง"); 
              thisTs.router.navigate(["/mainmenu/refundDeposits"]);
          }
        }
      });

    }

  ngOnInit() {
    this.socketService.setupSocketConnection();
    this.PortalUser = JSON.parse(localStorage.getItem("dpa_portal")); 
    this.InvestigateAndAppealCondition(this.PortalUser.contactid);
    this.startTimer();
  }

  async InvestigateAndAppealCondition(UID: any) {
    let thisTs = this;
    if (!this.Util.IsNullOrUndefined(UID)) {
      let drosWeb = ''
      let result: any = await this.Api.postCustomApi("SingleGateway", "GetRefID", { UID });
      
      if(!this.Util.IsNullOrUndefined(result) && result.length > 0  )
      {
        if (!this.Util.IsNullOrUndefined(result[0].authorizationUrl)) 
        {  
          drosWeb = result[0].authorizationUrl;
          sessionStorage.setItem("referenceId", result[0].referenceId)       
          window.open(drosWeb, "_blank");
        }
        else 
        {
          this.Util.WarningDialog("ไม่สามารถเชื่อมต่อกับระบบ Single GateWay ได้ กรุณาลองใหม่อีกครั้ง");
          thisTs.router.navigate(["/mainmenu/index"]);
        }
      }
      else 
      {
        this.Util.WarningDialog("ไม่สามารถเชื่อมต่อกับระบบ Single GateWay ได้ กรุณาลองใหม่อีกครั้ง");
        thisTs.router.navigate(["/mainmenu/index"]);
         
      }
    }
    else  {
      this.Util.WarningDialog("ไม่สามารถเชื่อมต่อกับระบบ Single GateWay ได้ กรุณาลองใหม่อีกครั้ง");
      thisTs.router.navigate(["/mainmenu/index"]);
       
    }
  }
 

  startTimer() { 
    const source = timer(1000, 2000);
    const abc = source.subscribe(val => { 
      if(val < 3600)
      {
        this.message = this.dhms(this.timeLeft - val);
      }
      else
      {
        let thisTs = this;
        this.Util.WarningDialog("ท่านไม่ได้ทำรายการในเวลาที่กำหนด กรุณาเข้าระบบใหม่อีกครั้งหลังจากทำการยืนยันตัวตนเสร็จสิ้น");
        thisTs.router.navigate(["/mainmenu/index"]);
      }
    });
  }


  dhms(t: number){
    var    minutes, seconds;  
    minutes = Math.floor(t / 60) % 60;
    t -= minutes * 60;
    seconds = t % 60;
    return [  
            minutes + ' นาที',
            seconds + ' วินาที'
           ].join(' ');
 }
  
  ngOnDestroy(){
    //prevent memory leak when component destroyed
    this._subscription.unsubscribe();
  }


}



// WEBPACK FOOTER //
// ./src/app/singlegatewaywait/singlegatewaywait.component.ts